import { DATE_FORMAT } from './constants';
import { nowInTimezone, getStoredUserTimezone } from './timezoneUtils';

const getDefaultDateRangeValues = ({
  initialValues = {},
  startName,
  endName,
  onlyDate = false,
  dateName,
  startAtStartOfDay = false
}) => {
  const values = { ...initialValues };
  const now = nowInTimezone(getStoredUserTimezone()).seconds(0).milliseconds(0);

  if (dateName && !values[dateName]) {
    values[dateName] = now.format(onlyDate ? DATE_FORMAT.unixDate : DATE_FORMAT.unixDateTime);
  }

  if (startName && !values[startName]) {
    values[startName] = (onlyDate || startAtStartOfDay ? now.clone().startOf('day') : now.clone().subtract(1, 'hour'))
      .format(onlyDate ? DATE_FORMAT.unixDate : DATE_FORMAT.unixDateTime);
  }

  if (endName && !values[endName]) {
    values[endName] = now.format(onlyDate ? DATE_FORMAT.unixDate : DATE_FORMAT.unixDateTime);
  }

  return values;
};

export default getDefaultDateRangeValues;
